module.exports = __webpack_public_path__ + "img/PlatformIcon.28108c38.svg";